'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExternalLink = (_dec = (0, _reactCssModules2.default)(_style2.default), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(ExternalLink, _React$Component);

  function ExternalLink() {
    (0, _classCallCheck3.default)(this, ExternalLink);
    return (0, _possibleConstructorReturn3.default)(this, (ExternalLink.__proto__ || (0, _getPrototypeOf2.default)(ExternalLink)).apply(this, arguments));
  }

  (0, _createClass3.default)(ExternalLink, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'a',
        {
          styleName: this.props.class,
          href: this.props.href,
          title: this.props.title,
          target: this.props.target
        },
        this.props.text
      );
    }
  }]);
  return ExternalLink;
}(_react2.default.Component), _class2.propTypes = {
  class: _react.PropTypes.string,
  href: _react.PropTypes.string.isRequired,
  text: _react.PropTypes.string.isRequired,
  title: _react.PropTypes.string,
  target: _react.PropTypes.string
}, _class2.defaultProps = {
  class: 'a-link'
}, _temp)) || _class);
exports.default = ExternalLink;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/ExternalLink/index.js
// module id = 177
// module chunks = 0